<div
    class="container close-box my-2 flex-row d-flex align-items-center p-3 justify-content-between"
    *ngIf="commerceService.commerce?.cashBox?.enabled && analyticsService.getExperimentVariant('cashbox')"
>
    <div class="d-flex flex-row align-items-center">
        <p class="mb-0 text-color">Abrir Caja</p>
        <img class="ms-2" src="assets/icons/svg/info-circle-black.svg" ngbTooltip="Abrir caja" data-placement="bottom" style="width: 18px; height: 18px" />
    </div>
    <label class="switch">
        <input type="checkbox" [checked]="cashboxService.isCashboxOpen$ | async" (click)="onToggleSwitch()" />
        <span class="slider">
            <span class="slider-text text-on">I</span>
            <span class="slider-text text-off">O</span>
        </span>
    </label>
</div>
<nav class="sidenav shadow-right menu pt-0 d-flex flex-column" id="sidenavAccordion" [ngClass]="sidenavStyle" data-cy="sideNav">
    <div class="sidenav-wrapper flex-grow-1 overflow-auto">
        <div class="sidenav-menu">
            <div class="nav">
                <ng-container *ngFor="let section of sideNavSections">
                    <div class="sidenav-menu-heading" *ngIf="section.text">{{ section.text }}</div>
                    <ng-container *ngFor="let item of section.items">
                        <sbpro-side-nav-item [sideNavItem]="sideNavItems[item]"></sbpro-side-nav-item>
                    </ng-container>
                </ng-container>
            </div>
        </div>

        <!-- Spacer element to push configuration to bottom -->
        <div class="flex-spacer"></div>

        <div class="sidenav-menu config-menu">
            <div class="nav">
                <div class="sidenav-menu-heading">{{ configSection.text }}</div>
                <ng-container *ngFor="let item of configSection.items">
                    <sbpro-side-nav-item [sideNavItem]="sideNavItems[item]"></sbpro-side-nav-item>
                </ng-container>
            </div>
        </div>
    </div>

    <div class="p-3 sidenav-footer-1 flex-shrink-0">
        <button
            *ngIf="(userService.user$ | async)?.permissions?.COMMERCE?.includes('create-and-edit-users')"
            class="btn btn-info py-2 px-3 border-0 shadow-sm mb-3 btn-crear-usuarios text-purple fw-bolder w-100"
            [routerLink]="['/comercio/usuarios-asociados']"
            (click)="analyticsService.analyticsCapture('sidenav_Crear usuarios button')"
        >
            + Crear usuarios <span class="badge rounded-pill text-bg-success bg-success ms-2">Gratis</span>
        </button>
        <div class="sidenav-footer-content" *ngIf="userService.user$ | async as user">
            <div class="sidenav-footer-subtitle">Registrado como:</div>
            <div class="sidenav-footer-title">{{ user.name }} {{ user.lastName }}</div>
        </div>
    </div>
</nav>
